// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-document-search',
    // #endregion
    // #region Properties
    data: () => ({
        filter: {
            type: 'carts',
            name: '',
            number: '',
            ordernumber: '',
            commission: '',
            datefrom: '2021-07-01',
            dateto: null
        },
        documents: {
            records: [],
            recordCount: 0,
            pageSize: 15
        },
        isShow: false,
        isSearching: false,
        isWorking: false
    }),
    // #endregion
    // #region Constructor
    beforeMount() {
        this.$host.eventBus.on('refresh', this.refresh);
    },
    mounted() {
        this.OnSearch(false);
    },
    beforeUnmount() {
        this.$host.eventBus.off('refresh', this.refresh);
    },
    // #endregion
    // #region Watch
    watch: {
        "$route.query"(value) {
            if (!this.isSearching) {
                this.OnSearch(false);
            }
        },
    },
    // #endregion
    // #region Core
    methods: {
        OnRefresh(event) {
            //Default
            event.preventDefault();
            //Notify
            this.$host.eventBus.emit('refresh');
        },
        OnShowFilter() {
            alert('TODO');
        },
        showDetails(cartID) {
            host.notification.showModal2(host.components.getComponent('g-document-dialog'), { documentType: 'cart', documentID: cartID }, { size: 'large' });
        },
        async refresh() {
            this.OnSearch(false);
        },
        async OnSearch(resetPage = true) {
            try {
                //Init
                this.isSearching = true;
                if (resetPage) {
                    this.isWorking = true;
                }
                //Page      
                if (resetPage) {
                    let tQuery = Object.assign({}, this.$route.query);
                    delete tQuery["p"];
                    this.$router.replace({ query: tQuery });
                }
                //Data
                let tData = {
                    filter: this.filter,
                    page: parseInt(this.$route?.query?.p ?? "1"),
                    size: this.documents.pageSize
                };
                //Load
                let tResult = await host.api.post('commerce/history', tData);
                //Document
                this.documents.records = tResult.data.result;
                this.documents.recordCount = tResult.data.totalRecords;
                //Finish
                this.isSearching = false;
                this.isWorking = false;
            }
            catch (e) {
                //Finish
                this.isSearching = false;
                this.isWorking = false;
                //Error
                host.notification.showError(e);
            }
        },
    },
    // #endregion
});
// #endregion
